<template>
  <div class="script-section">
    <el-row v-if="createByGpt && copyScriptData" class="script-name-content" type="flex" align="middle">
      <div class="script-name">{{ scriptIndex + 1 }}. {{ copyScriptData.script_name }}</div>
      <el-popover v-model="scriptNamePopoverVisible" width="400" trigger="click" placement="top" title="编辑脚本名称" @show="handleShowScriptNamePopover">
        <el-input v-model="scriptName" type="textarea" rows="3" placeholder="请输入脚本名称" />
        <el-row type="flex" align="middle" justify="end" style="margin-top: 10px">
          <el-button size="mini" @click="scriptNamePopoverVisible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="handleconfirmScriptName">确定</el-button>
        </el-row>
        <i slot="reference" class="el-icon-edit" />
      </el-popover>
      <el-row type="flex" align="center" style="flex: 1" justify="end">
        <el-popover v-model="reloadVideoScriptPopoverVisible" width="400" trigger="click" placement="top" @show="handleShowReloadVideoScriptPopover">
          <el-form ref="scriptForm" label-position="top">
            <el-form-item v-if="povoverType === 'evaluate'" label="请问这条AI脚本对您有帮助吗？">
              <el-row class="evaluate-icon-content" type="flex" align="middle">
                <svg-icon icon-class="like" :class="[evaluate === 'like' ? 'active' : '']" @click="evaluate = 'like'" />
                <svg-icon icon-class="like" :class="[evaluate === 'dislike' ? 'dislike active' : 'dislike']" @click="evaluate = 'dislike'" />
              </el-row>
            </el-form-item>
            <el-form-item :label="reloadAndEvaluatePopoverTitle">
              <el-radio-group v-model="reloadReasonIndex" @change="reloadReason = ''">
                <el-radio v-for="(item, index) in popoverReasonList" :key="item" :label="index" style="display: block; line-height: 24px">{{ item }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-input v-model="reloadReason" type="textarea" rows="4" :disabled="reloadReasonIndex !== 4" placeholder="请输入其他原因或者建议" />
          </el-form>
          <el-row type="flex" align="middle" justify="end" style="margin-top: 10px">
            <el-button size="mini" @click="reloadVideoScriptPopoverVisible = false">取消</el-button>
            <el-button size="mini" type="primary" @click="handleReloadVideoScript">提交</el-button>
          </el-row>
          <el-row slot="reference" type="flex" align="middle">
            <el-button type="text" icon="el-icon-refresh-right" @click="showReloadPopover">重新生成</el-button>
            <el-button :loading="evaluateLoading" type="text" icon="el-icon-chat-line-square" @click="showEvaluatePopover">点赞/吐槽</el-button>
          </el-row>
        </el-popover>
      </el-row>
    </el-row>
    <main v-loading="againGenerateVideoScriptLoading" class="script-section-content">
      <div class="deconstruct-content">
        <el-alert v-if="copyScriptData" :title="`营销卖点：${copyScriptData.deconstruct.selling_points.join('、')}`" type="warning" :closable="false" class="deconstruct-item" />
        <el-alert v-if="copyScriptData" :title="`爽点：${copyScriptData.deconstruct.cool_points.join('、')}`" type="success" :closable="false" class="deconstruct-item" />
      </div>
      <el-row class="details-header" type="flex" align="center">
        <el-row v-for="(item, index) in videoScriptData" :key="index" class="header-item" type="flex" align="center">
          <span class="tag-content" @mouseenter="handleMouseEnterVideoScript(index)" @mouseleave="handleMouseLeaveVideoScript"><el-tag>{{ item.synopsis }}</el-tag></span>
          <div class="split">+</div>
        </el-row>
      </el-row>
      <div class="details-content">
        <span v-for="(item, index) in editStatus ? copyVideoScript : videoScriptData" :key="index" :class="['detail-item', index === activeVideoScriptKey ? 'active' : '']" :contenteditable="editStatus" @blur="(event) => handleBlurDetailItem(event, index)">{{ item.text }}</span>
      </div>
      <div v-if="edit" class="edit-btn">
        <template v-if="!editStatus">
          <el-button v-if="createByGpt" :loading="saveScriptByGptLoading" type="text" icon="el-icon-document" @click="handleSaveScriptByGpt">保存至脚本库</el-button>
          <el-button type="text" icon="el-icon-edit" @click="handleEditScript">编辑</el-button>
          <el-button type="text" icon="el-icon-document-copy" @click="handleCopyScript">复制</el-button>
        </template>
        <template v-if="editStatus">
          <el-button :loading="saveScriptLoading" type="primary" @click="saveScript">保存</el-button>
          <el-button :loading="saveScriptLoading" @click="cancelScript">取消</el-button>
        </template>
      </div>
    </main>
  </div>
</template>

<script>
import { deepClone } from '@/utils/index'
import { againGenerateVideoScript, addVideoScript, evaluateVideoScript } from '@/api/dsp/videoScript'

export default {
  name: 'ScriptSection',
  props: {
    videoScript: {
      type: Array,
      default: () => []
    },
    scriptId: {
      type: String,
      default: ''
    },
    scriptIndex: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: false
    },
    createByGpt: {
      type: Boolean,
      default: false
    },
    saveScriptFun: {
      type: Function,
      default: () => {}
    },
    scriptData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      activeVideoScriptKey: '',
      editStatus: false,
      saveScriptLoading: false,
      scriptNamePopoverVisible: false,
      reloadVideoScriptPopoverVisible: false,
      copyVideoScript: [],
      copyScriptData: null,
      scriptName: '',
      reloadReason: '',
      reloadReasonIndex: '',
      againGenerateVideoScriptLoading: false,
      saveScriptByGptLoading: false,
      evaluateLoading: false,
      evaluate: 'dislike',
      povoverType: ''
    }
  },
  computed: {
    videoScriptData() {
      if (this.createByGpt) {
        return this.copyScriptData.content
      }

      return this.videoScript
    },
    reloadAndEvaluatePopoverTitle() {
      if (this.povoverType === 'evaluate') {
        return this.evaluate === 'dislike' ? '您觉得没有帮助的原因是？' : '您觉得有帮助的原因是？'
      }
      return '您觉得需要重新生成的原因是？'
    },
    popoverReasonList() {
      if (this.evaluate === 'like' && this.povoverType === 'evaluate') {
        return ['话术内容与产品贴合度高', '脚本内容质量高', '脚本解构清晰', '脚本语句通顺', '其他']
      }
      return ['话术内容与产品不符', '脚本可能不过审', '整体话术过于生硬', '脚本语句不通顺', '其他']
    }
  },
  watch: {
    scriptData: {
      handler(val) {
        if (val) {
          if (this.copyScriptData) {
            this.copyScriptData.gpt_id = val.gpt_id
          } else {
            this.copyScriptData = deepClone(val)
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleMouseEnterVideoScript(key) {
      this.activeVideoScriptKey = key
    },
    handleMouseLeaveVideoScript() {
      this.activeVideoScriptKey = ''
    },
    handleEditScript() {
      this.$set(this, 'copyVideoScript', deepClone(this.videoScriptData))
      this.editStatus = true
    },
    handleCopyScript() {
      let str = ''
      this.videoScriptData.forEach(item => {
        str += `${item.synopsis}：${item.text}\n`
      })
      this.copyLink(str)
    },
    saveScript() {
      if (this.scriptId && !this.createByGpt) {
        this.saveScriptLoading = true
        this.saveScriptFun({ id: this.scriptId, content: this.copyVideoScript }).then(res => {
          this.copyVideoScript = res.data
          this.$emit('save', this.copyVideoScript)
          this.$message.success(res.message)
          this.editStatus = false
        }).finally(() => {
          this.saveScriptLoading = false
        })
      } else {
        this.$set(this.copyScriptData, 'content', deepClone(this.copyVideoScript))
        this.editStatus = false
      }
    },
    handleSaveScriptByGpt() {
      const param = deepClone(this.scriptData.scriptForm)
      param.gpt_id = this.copyScriptData.gpt_id
      param.script_name = this.copyScriptData.script_name
      param.synopsis = this.copyScriptData.synopsis
      param.content = this.copyScriptData.content
      this.saveScriptByGptLoading = true
      addVideoScript(param).then(res => {
        this.$message.success(res.message)
      }).finally(() => {
        this.saveScriptByGptLoading = false
      })
    },
    cancelScript() {
      this.editStatus = false
    },
    handleBlurDetailItem(e, index) {
      const text = e.target.innerText
      this.copyVideoScript[index].text = text
    },
    handleShowScriptNamePopover() {
      this.scriptName = this.scriptData.script_name
    },
    handleconfirmScriptName() {
      this.copyScriptData.script_name = this.scriptName
      this.scriptNamePopoverVisible = false
    },
    handleShowReloadVideoScriptPopover() {
      this.reloadReason = ''
      this.reloadReasonIndex = ''
    },
    showReloadPopover() {
      this.povoverType = 'reload'
    },
    showEvaluatePopover() {
      this.evaluate = 'dislike'
      this.povoverType = 'evaluate'
    },
    handleReloadVideoScript() {
      if (this.povoverType === 'reload') {
        let reason = this.reloadReasonIndex !== '' ? this.popoverReasonList[this.reloadReasonIndex] : ''
        if (this.reloadReasonIndex === 4) {
          reason = this.reloadReason
        }
        const param = {
          gpt_id: this.copyScriptData.gpt_id,
          script_index: this.copyScriptData.script_index,
          reason,
          clique_id: this.copyScriptData.scriptForm.clique_id,
          clique_name: this.copyScriptData.scriptForm.clique_name
        }
        this.againGenerateVideoScriptLoading = true
        this.reloadVideoScriptPopoverVisible = false
        againGenerateVideoScript(param).then(res => {
          this.$emit('updateGptId', this.copyScriptData.gpt_id, res.data.gpt_id, this.copyScriptData.script_index)
          const againData = res.data.video_script[0]
          againData.gpt_id = res.data.gpt_id
          this.$set(this, 'copyScriptData', againData)
          this.$set(this, 'copyVideoScript', deepClone(againData.content))
        }).finally(() => {
          this.againGenerateVideoScriptLoading = false
        })
      }

      if (this.povoverType === 'evaluate') {
        this.evaluateLoading = true
        this.reloadVideoScriptPopoverVisible = false
        const param = {
          gpt_id: this.copyScriptData.gpt_id,
          script_index: this.copyScriptData.script_index,
          reason: this.reason,
          evaluate: this.evaluate,
          clique_id: this.copyScriptData.scriptForm.clique_id,
          clique_name: this.copyScriptData.scriptForm.clique_name
        }
        evaluateVideoScript(param).then(res => {
          this.$emit('updateGptId', this.copyScriptData.gpt_id, res.data.gpt_id, this.copyScriptData.script_index)
          this.$set(this.copyScriptData, 'gpt_id', res.data.gpt_id)
          this.$message.success(res.message)
        }).finally(() => {
          this.evaluateLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/mixin.scss";
.script-section {
  .script-name-content {
    padding-bottom: 8px;
    .el-icon-edit {
      margin-left: 6px;
      cursor: pointer;
      color: #409eff;
    }
  }
  .script-section-content {
    border: solid 1px #dfe0e2;
    border-radius: 8px;

    .deconstruct-content {
      padding: 0 14px;
      .deconstruct-item {
        margin-top: 14px;
        padding: 4px 8px;
      }
    }
  }
  .details-header {
    padding: 14px 14px 0;
    flex-wrap: wrap;
    .header-item {
      margin-bottom: 10px;
      .el-tag {
        cursor: pointer;
        margin: 0;
      }
      .split {
        margin: 0 6px;
        color: #999;
      }

      &:last-child .split {
        display: none;
      }
    }
  }

  .details-content {
    padding: 0 14px 14px;
    max-height: 280px;
    overflow: auto;
    text-align: left;
    font-size: 14px;
    .detail-item {
      color: #323335;

      &.active {
        background: #e5f5ff;
      }

      &:focus {
        border: none;
        outline: none;
      }
    }

    @include scrollBar();
  }

  .edit-btn {
    padding: 6px 14px;
    border-top: 1px solid #dfe0e2;

    .montage-btn {
      float: right;
    }
  }
}
.evaluate-icon-content {
  .svg-icon {
    font-size: 30px;
    margin: 0 20px;
    cursor: pointer;
    &.active,
    &:hover {
      color: #409eff;
    }
  }
  .dislike {
    transform: rotate(180deg);
  }
}
</style>
